import React from 'react'
import { useBreakpoint } from 'utils/Hooks'
import ProjectMineDesktop from './ProjectMineDesktop'
import ProjectMineMobile from './ProjectMineMobile'

const ProjectMine: React.FC = () => {
  const { isMediumscreenAbove } = useBreakpoint()
  return isMediumscreenAbove ? <ProjectMineDesktop /> : <ProjectMineMobile />
}

export default ProjectMine
